export const PPMT = (
	rate: number, // InterestRate ÷ TermsInYear
	per: number, //	TermLength (usually 1)
	nper: number, // Terms until dueDate
	pv: number, // Restbalance
	fv: number = 0, // Desired endresult (usually 0)
	type: number = 0 // Type (usually 0)
) => {
	if (per < 1 || per >= nper + 1) return 0;
	var _pmt = PMT(rate, nper, pv, fv, type);
	var _ipmt = IPMT(pv, _pmt, rate, per - 1);
	return _pmt - _ipmt;
};

export const PMT = (
	rate: number, // InterestRate ÷ TermsInYear
	nper: number, // Terms until dueDate
	pv: number, // Restbalance
	fv: number = 0, // Desired endresult (usually 0)
	type: number = 0 // Type (usually 0)
) => {
	if (!fv) fv = 0;
	if (!type) type = 0;

	if (rate === 0) return -(pv + fv) / nper;

	var pvif = Math.pow(1 + rate, nper);
	var pmt = (rate / (pvif - 1)) * -(pv * pvif + fv);

	if (type === 1) {
		pmt /= 1 + rate;
	}

	return pmt;
};

export const IPMT = (
	pv: number, // Restbalance
	pmt: number, // TermAmount (PMT())
	rate: number, // InterestRate ÷ TermsInYear
	per: number // TermLength (usually 1)
) => {
	var tmp = Math.pow(1 + rate, per);
	return 0 - (pv * tmp * rate + pmt * (tmp - 1));
};

export const InterestAmountForPeriod = (restbalance: number, interestRate: number, nDays: number, termLength: number) => {
	return Math.round(restbalance * interestRate * (nDays / 360) / termLength);
}